<!--전역스타일적용해당안됨-->
<template>
  <div class="button-switch-container">
    <div class="button-group column">
      <ButtonContext />

      <button class="button-switch download-button" @click="handleDownloadTgt">
        <span>📥 타겟 메시지 다운로드</span>
      </button>

      <button class="button-switch" @click="handleToggleHintBox">
        <p>💡 힌트박스 숨기기</p>
        <ToggleSwitch :modelValue="isDisabledHintBox" @update:modelValue="handleToggleHintBox" />
      </button>
    </div>
    <div class="conference-group">
      <input v-model="loginId" type="text" placeholder="Login ID" />
      <div class="container-radio">
        <!-- 라디오 버튼 리스트 -->
        <label v-for="language in PAGE_LANGUAGES" :key="language.code">
          {{ language.nameInKorean }}
          <input v-model="languageSelected" type="radio" :value="language.code" />
        </label>
      </div>
      <ButtonProcess :disabled="isDisabledButtonSend" @click="onClickSendFc">언어 변경</ButtonProcess>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { storeToRefs } from 'pinia';

import ButtonContext from '@/components/domains/chat/common/ButtonContext.vue';
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { useMessagesCall } from '@/composables/domains/chat/useMessagesCall';
import { PAGE_LANGUAGES } from '@/static/languages';
import { useSocketStore } from '@/stores/socket';
import { useToastStore } from '@/stores/toast.js';

const socketStore = useSocketStore();
const toastStore = useToastStore();

const { isDisabledHintBox } = storeToRefs(toastStore);

const { messageList } = useMessagesCall();

const loginId = ref('');
const languageSelected = ref('');

const isDisabledButtonSend = computed(() => {
  return [loginId.value, languageSelected.value].some((value) => value.trim() === '');
});

const onClickSendFc = () =>
  socketStore.sendMessageFc({
    generalAttribute: {
      loginId: loginId.value,
      languageCode: languageSelected.value,
    },
  });

const handleToggleHintBox = () => {
  isDisabledHintBox.value = !isDisabledHintBox.value;
};

const handleDownloadTgt = () => {
  const csvRows = messageList.value
    .filter((itemFilter) => itemFilter.flag === 'tr')
    .flatMap((itemMap) => {
      const contentJoined = itemMap.tgt.contents.map((itemContent) => itemContent.content).join('');
      return { content: contentJoined };
    });

  const headers = ['순번', 'content'];

  const csvEscape = (cellString) => {
    if (cellString == null) return '';
    const cellStringFormatted = String(cellString).replace(/"/g, '""');
    return /[",\n\r]/.test(cellStringFormatted) ? `"${cellStringFormatted}"` : cellStringFormatted;
  };

  const csvConvert = (csvRows: Array<Record<string, unknown>>) => {
    const lineHeader = headers.join(',');
    const lines = csvRows.map((row, index) =>
      headers
        .map((itemHeader) => {
          if (itemHeader === '순번') return index + 1;
          return csvEscape(row[itemHeader]);
        })
        .join(',')
    );
    return [lineHeader, ...lines].join('\r\n');
  };

  const csvData = csvConvert(csvRows);
  const blob = new Blob(['\uFEFF' + csvData], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const aTag = document.createElement('a');
  aTag.href = url;
  aTag.download = `타겟_메세지_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(aTag);
  aTag.click();
  document.body.removeChild(aTag);
  URL.revokeObjectURL(url);
};
</script>

<style scoped>
.button-switch-container {
  position: fixed;
  bottom: 10%;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  font-family: sans-serif;
}

.button-group {
  display: flex;
  gap: 8px;
}

.button-group.column {
  flex-direction: column;
}

.button-wrap {
  display: flex;
  gap: 10px;
  width: 15rem;
}

.button-group.row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.language-group {
  background-color: #f9fafb;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 220px;
}

.button-label {
  font-weight: 600;
  font-size: 15px;
  color: #111827;
  margin-bottom: 4px;
}

.button-switch {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  flex: 1;
  white-space: nowrap;
}

.button-switch:hover {
  background-color: #1d4ed8;
}

.button-switch:focus {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
}

.context-button {
  background-color: #f59e0b;
}

.context-button:hover {
  background-color: #d97706;
}

.switch-button {
  background-color: #10b981;
}

.switch-button:hover {
  background-color: #059669;
}

.container-radio {
  height: 300px;
  overflow-y: scroll;
}
</style>
